import React from 'react';
import {formatarReal} from '../../util/numberUtil';

const ModalExcluirCentroCusto = ({excluir, centroCustoSelecionado, limparSelecaoCentroCusto}) => (
    <div className="modal fade" id="modalExcluirCentroCusto" tabIndex="-1" role="dialog"
         aria-labelledby="modalExcluirCentroCusto" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">delete</span>
                        Excluir Centro de Custo
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja excluir o registro{' '}
                        <strong>{centroCustoSelecionado ? centroCustoSelecionado.ocorrencia : ''}</strong>{' '}
                        no valor de{' '}
                        <strong>{centroCustoSelecionado ? formatarReal(centroCustoSelecionado.valorTotalGasto) : '0,00'}</strong>?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                            onClick={limparSelecaoCentroCusto}>
                        Cancelar
                    </button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                            onClick={excluir}>
                        <span className="material-icons" style={{ fontSize: 15 }}>delete</span>
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export default ModalExcluirCentroCusto;
